import { defineNuxtPlugin } from '#app';
import { Field, Form, ErrorMessage, defineRule, configure } from 'vee-validate';
import { alpha_spaces, required, email, min, max, max_value, min_value, numeric } from '@vee-validate/rules';
import phoneNumberValidation from '~/utils/phoneNumberValidation';

export { phoneNumberValidation };

export default defineNuxtPlugin(nuxtApp => {
    defineRule('email', (value) => {
        if (!email(value)) {
            return 'Enter a valid email';
        }
        return true;
    });
    defineRule('required', (value) => {
        if (!required(value)) {
            return 'This field is required';
        }
        return true;
    });
    defineRule('numeric', (value) => {
        if (!required(value)) {
            return 'Enter a valid number';
        }
        return true;
    });
    defineRule('numeric', (value) => {
        if (!required(value)) {
            return 'Enter a valid number';
        }
        return true;
    });
    defineRule('min_value', (value, [min], ctx) => {
        if (!min_value(value, { min: Number(min) })) {
            return `${ctx.field} cannot be less than ${min}`;
        }
        return true;
    });
    defineRule('max_value', (value, [max], ctx) => {
        if (!max_value(value, { max: Number(max) })) {
            return `${ctx.field} cannot be greater than ${max}`;
        }
        return true;
    });
    defineRule('max_value_new_quota', (value, [max], ctx) => {
        if (!max_value(value, { max: Number(max) })) {
            return `${ctx.field} cannot be greater than ${max}, based on the current total sample size and existing quotas`;
        }
        return true;
    });
    defineRule('min_value_quota', (value, [min], ctx) => {
        if (!min_value(value, { min: Number(min) })) {
            return `${ctx.field} cannot be less than ${min}, based on the current existing quotas`;
        }
        return true;
    });
    defineRule('phoneNumbers', (value) => {
        if (!phoneNumberValidation(value)) {
            return 'Enter a valid mobile number using digits, an optional +, and hyphens only';
        }
        return true;
    });
    defineRule('alpha_spaces', alpha_spaces);
    defineRule('email', email);
    defineRule('min', min);
    defineRule('max', max);
    defineRule('numeric', numeric);
    defineRule('booleanToggle', (value) => {
        if (!(value === true || value === false)) {
            return `Please answer this question`;
        }
        return true;
    });

    nuxtApp.vueApp.component('VForm', Form);
    nuxtApp.vueApp.component('VField', Field);
    nuxtApp.vueApp.component('ErrorMessage', ErrorMessage);


    // Optional: Configure global settings
    configure({
        // Your configurations here
    });
});
